import React, { FC } from 'react';
import { IoIosInformationCircleOutline } from 'react-icons/io';
import { twMerge } from 'tailwind-merge';
import { IoArrowBackOutline } from 'react-icons/io5';
import TooltipWrapper, { TriggerType } from '@/components/new-design/ToolTipWrapper';
import { formatValue } from '@/pages/agentDashboard/utils/utils';
import LoadingSpinner from '@/components/LoadingSpinner/LoadingSpinner';

interface StatCardProps {
  icon: React.ReactNode;
  title: string;
  value?: string | number;
  change?: number;
  info?: string;
  isLoading?: boolean;
}

const StatCard: FC<StatCardProps> = ({ icon, title, info, value, change, isLoading = false }) => {
  const isRaising = change && change > 0;
  const raisingIcon = (
    <IoArrowBackOutline
      className={twMerge(
        'h-5 w-5',
        isRaising
          ? 'rotate-90 text-ph-green-dark'
          : change === 0 || change === null
            ? 'hidden'
            : '-rotate-90 text-ph-red-secondary',
      )}
    />
  );

  return (
    <div className="flex items-center gap-3">
      <div
        className={`flex h-14 w-14 items-center justify-center rounded-full border-[1px] border-ph-white-10 bg-ph-white-10`}
      >
        {icon}
      </div>
      <div className="flex flex-col">
        <div className="flex items-center gap-1">
          <div className="whitespace-nowrap text-xs font-bold text-ph-white-30">{title}</div>
          {info && (
            <TooltipWrapper
              content={<span className="text-xs font-semibold text-white">{info}</span>}
              fullDimensions={false}
              triggerType={TriggerType.HOVER}
            >
              <IoIosInformationCircleOutline className="h-4 w-4 cursor-pointer text-ph-white-30" />
            </TooltipWrapper>
          )}
        </div>
        {isLoading ? (
          <LoadingSpinner size="6" className="my-1" />
        ) : (
          <div className={twMerge('text-3xl font-bold leading-5 text-ph-white', change !== undefined && 'text-2xl')}>
            {value !== undefined ? formatValue(value) : '-'}
          </div>
        )}

        {change !== undefined && (
          <div className="flex items-center gap-1">
            {raisingIcon}
            <span
              className={twMerge(
                'font-bold',
                isRaising
                  ? 'text-ph-green-dark'
                  : change === 0 || change === null
                    ? 'text-ph-white-30'
                    : 'text-ph-red-secondary',
              )}
            >
              {Math.floor(change * 100) / 100}%
            </span>
          </div>
        )}
      </div>
    </div>
  );
};

export default StatCard;
